import React from 'react';
import { motion } from 'framer-motion';

const Screenshots = () => {
    // App screenshots
    const screenshots = [
        { title: 'Ana Ekran', img: '/images/screen-1.jpeg' },
        { title: 'Soru Çözümü', img: '/images/screen-2.jpeg' },
        { title: 'İstatistikler', img: '/images/screen-3.jpeg' },
        { title: 'Konu Takibi', img: '/images/screen-4.jpeg' },
        { title: 'Profil', img: '/images/screen-5.jpeg' },
        { title: 'Ayarlar', img: '/images/screen-6.jpeg' },
        { title: 'Bildirimler', img: '/images/screen-7.jpeg' },
        { title: 'Test Ekranı', img: '/images/screen-8.jpeg' },
        { title: 'Sonuçlar', img: '/images/screen-9.jpeg' },
        { title: 'Ders Programı', img: '/images/screen-10.jpeg' },
        { title: 'Hedefler', img: '/images/screen-11.jpeg' },
        { title: 'Rozetler', img: '/images/screen-12.jpeg' },
        { title: 'Siralama', img: '/images/screen-13.jpeg' },
    ];

    // Duplicate the list to ensure seamless infinite scrolling
    const marqueeContent = [...screenshots, ...screenshots];

    return (
        <section className="section screenshots-section" id="screenshots">
            <div className="container" style={{ maxWidth: '100%', padding: 0 }}>
                <div className="section-header">
                    <motion.h2
                        className="section-title"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5 }}
                    >
                        Uygulama İçi Görüntüler
                    </motion.h2>
                    <motion.p
                        className="section-subtitle"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: 0.2 }}
                    >
                        Kullanıcı dostu arayüzümüzü yakından inceleyin.
                    </motion.p>
                </div>

                <motion.div
                    className="screenshots-marquee-container"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                >
                    <div className="screenshots-track">
                        {marqueeContent.map((item, index) => (
                            <div key={index} className="screenshot-slide">
                                <div className="screenshot-frame">
                                    <img
                                        src={item.img}
                                        alt={item.title}
                                        style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '20px' }}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default Screenshots;
